import Vue from "vue";
import swal from "sweetalert";

Vue.prototype.swal = swal;
